import * as Actions from '../types/router';
import { createAction } from '../utils';
export const logout = () => createAction(Actions.LOGOUT);
